/**
 * Utility function for retreiving mapboxgl bottom right navigation control and
 * prepending / appending div containers that will serve as mounts for portaling
 * custom map controls.
 *
 * @export addCustomControlMounts
 * @param {*} setCustomControlNodes CB for setting the mountable nodes in the map container
 */
// TODO: Rename.. Use this for all portalled map mounts
export function addCustomControlMounts(setCustomControlNodes) {
  const bottomRightElement = document.querySelector(
    '.mapboxgl-ctrl-bottom-right'
  );
  const bottomLeftElement = document.querySelector(
    '.mapboxgl-ctrl-bottom-left'
  );
  const topRigthElement = document.querySelector('.mapboxgl-ctrl-top-right');
  const ctrlButtonSet = document.querySelector(
    '.mapboxgl-ctrl.mapboxgl-ctrl-group'
  );

  const customCtrlGroupContainer = document.createElement('div');
  const customRefocusContainer = document.createElement('div');
  const customListingSummaryContainer = document.createElement('div');
  const customHoaInfoBoxContainer = document.createElement('div');

  customRefocusContainer.classList.add('mapboxgl-ctrl-custom-refocus-button');
  customCtrlGroupContainer.classList.add('mapboxgl-ctrl-custom-ctrl-group');
  customListingSummaryContainer.classList.add(
    'mapboxgl-ctrl-custom-properties-summary'
  );
  customHoaInfoBoxContainer.classList.add('deckard-custom-hoa-info-box');

  // FIXME: What if it's not there yet?
  if (
    topRigthElement &&
    bottomRightElement &&
    ctrlButtonSet &&
    bottomLeftElement
  ) {
    topRigthElement.prepend(customListingSummaryContainer);
    bottomRightElement.prepend(customCtrlGroupContainer);
    ctrlButtonSet.prepend(customRefocusContainer);
    bottomLeftElement.prepend(customHoaInfoBoxContainer);

    setCustomControlNodes({
      listingSummaryBtn: customListingSummaryContainer,
      mapLayerCtrlGroup: customCtrlGroupContainer,
      refocusBtn: customRefocusContainer,
      hoaInfoBox: customHoaInfoBoxContainer,
    });
  }
}
